import { Directive, ElementRef, HostListener, Input } from "@angular/core";
import { isNotEmptyValue } from "kwikid-toolkit";
import { formatCurrency } from "./input-currency.helpers";
import { TKwikUIInputCurrencyType } from "./input-currency.definitions";

@Directive({
  selector: "[currencyType]"
})
export class NumericCurrencyTypeDirective {
  @Input("currencyType") currencyType: TKwikUIInputCurrencyType;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener("input", ["$event"])
  onInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    let value = String(inputElement.value).replace(/[^0-9.-]/g, ""); // Remove non-numeric characters except the decimal point

    // Ensure only one decimal point is present
    const decimalParts = value.split(".");
    if (decimalParts.length > 2) {
      value = `${decimalParts[0]}.${decimalParts[1]}`;
    }

    if (isNotEmptyValue(value)) {
      value = formatCurrency(this.currencyType, value);
    }

    inputElement.value = value;
  }
}
